import { goalbookUrls } from "@/util/links.js";
import { useUserStore } from "@/authentication/user.store.js";
import { RouteLocationNormalized } from "vue-router";

type nextFunction = (to?: string | Partial<RouteLocationNormalized> | false) => void

export function internalOrSchoolAdminRouteGuard(to: RouteLocationNormalized, from: RouteLocationNormalized, next: nextFunction): void {
  const userStore = useUserStore()

  // Only check for school admin access on routes that require it
  const requiresInternalOrSchoolAdmin = to.matched.some(record => record.meta.requiresInternalOrSchoolAdmin)
  
  if (!requiresInternalOrSchoolAdmin) {
    next()
    return
  }

  const checkAndHandleAccess = () => {
    // Allow access if user is school admin, super admin, or Goalbook business user
    if (userStore.isSchoolAdmin || userStore.isSuperAdmin || userStore.isGoalbookBusinessUser) {
      next()
      return
    }
    
    // Redirect to home if not school admin, super admin, or Goalbook business user
    if (!goalbookUrls.toolkitHome) {
      console.error('toolkitHome URL not configured');
      next(false)
      return
    }
    globalThis.location.replace(goalbookUrls.toolkitHome)
  }

  // Wait for user to be fetched before checking permissions
  if (userStore.fetching) {
    userStore.pushOnetimeCallback(checkAndHandleAccess)
    return
  }

  checkAndHandleAccess()
}
